import React from "react";
import withRouter from "../../../common/hooks/withRouter";
import {connect} from "react-redux";
import {Filter} from "../../../common/components/Filter";
import {setDPListFilters, updateDPListFilters} from "../actions/DataProviderActions";

export class DataProvidersSidebarFilters extends React.Component {

    handleDPFilter = (filterOption) => {
        this.props.setDPListFilters(filterOption, "provider");
        this.props.updateDPListFilters();
    }

    render() {

        return (
            <div className="sidebar-filter-container">
                <Filter
                    placeholder="Data Provider"
                    handleFilter={this.handleDPFilter}
                    options={this.props.dpFilterOptionsObj.dpFilterOptions}
                    value={this.props.dpFilters.providerNameFilter}
                />
                <Filter
                    placeholder="Status"
                    isDisabled={true}
                />
                <Filter
                    placeholder="Matching Elements"
                    isDisabled={true}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    dpFilterOptionsObj: state.veritas.providers.dpFilterOptionsObj,
    dpFilters: state.veritas.providers.dpFilters,
});

const mapDispatchToProps = dispatch => ({
    setDPListFilters: (filterOption, type) => {dispatch(setDPListFilters(filterOption, type))},
    updateDPListFilters: () => {dispatch(updateDPListFilters())},
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(DataProvidersSidebarFilters))
